import { Link, useLocation } from 'react-router-dom';
import './NavBar.css';

function NavBar({ user, logOut }) {
    const location = useLocation();
    if (!user) return null;

    const getActiveClass = (path) => location.pathname === path ? 'nav-button active' : 'nav-button';

    return (
        <header className="navbar-header">
            <div className="navbar-identity">
                <img
                    src="https://s3-us-west-2.amazonaws.com/heartfulnessweb/en/wp-content/uploads/2019/04/05114150/LTM-logo_updated.png"
                    alt="Logo"
                    className="navbar-logo"
                />
                <h2 className="navbar-title">Zoom Meeting Scheduler</h2>
            </div>
            <nav>
                <ul className="navbar-nav">
                    <li><Link to="/home"><button className={getActiveClass('/home')}>My Meetings</button></Link></li>
                    <li><Link to="/available"><button className={getActiveClass('/available')}>Available Slots</button></Link></li>
                    {user.role === 'ADMIN' && (
                        <li><Link to="/admin"><button className={getActiveClass('/admin')}>Admin</button></Link></li>
                    )}
                    <li><button onClick={logOut} className="logout-button">Logout</button></li>
                </ul>
            </nav>
        </header>
    );
}

export default NavBar;
